var map = {
	"./logo-bocconi.svg": 3853,
	"./logo-caltech.svg": 3854,
	"./logo-cambridge.svg": 3855,
	"./logo-edinburgh.svg": 3856,
	"./logo-oxford.svg": 3857,
	"./logo-texas.svg": 3858
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3852;